import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { callsSummarySelector } from '../selectors/dashboardSelector';
import { getCallsSummaryRequest } from '../actions/dashboardActions';
import CallSummary from '../components/CallSummary/CallSummary';

const mapStateToProps = createStructuredSelector({ summary: callsSummarySelector });
const mapDispatchToProps = { getCallsSummaryRequest };

export default connect(mapStateToProps, mapDispatchToProps)(CallSummary);
